module.exports = __webpack_public_path__ + "static/media/edit-stay.db561030.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/edit-stay.svg
// module id = 818
// module chunks = 0